import React from 'react';
import { motion } from 'framer-motion';
import { FileText, CheckCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const Customs = () => {
  const services = [
    'Import and export entry coordination',
    'Commodity-code guidance',
    'Documentation review',
    'Duty and tax coordination',
    'Temporary imports',
    'Returned goods',
    'Transit movements',
    'Urgent customs intervention',
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO title="Customs Coordination | Aero Time Critical" description="Customs coordination for import and export: entry coordination, commodity-code guidance, documentation review, duty and tax coordination, temporary imports and transit." path="/customs" />
      <PageHero
        badge="CUSTOMS SUPPORT"
        BadgeIcon={FileText}
        title="Customs"
        titleAccent="Coordination"
        description="We coordinate smooth cross-border movement, working with customs authorities and approved partners to minimise delays and keep your shipments compliant."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/a2ip5pq6_CC%20pic%201.png"
      />

      <section className="bg-[#F7F9FB] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[#0089D0] font-semibold tracking-wide uppercase text-sm">Seamless Border Crossing</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-8 text-[#003057]">
                Complete Customs Coordination
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {services.map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle className="text-[#0089D0] flex-shrink-0" size={22} />
                    <span className="text-[#003057] font-medium">{item}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/a2ip5pq6_CC%20pic%201.png"
                alt="Customs coordination and documentation for cross-border freight"
                className="w-full h-[450px] object-cover rounded-lg shadow-xl"
                loading="lazy"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection
        title="Need Customs Support?"
        description="Our team can coordinate all your import and export customs requirements"
        buttonText="Contact Customs Team"
        buttonLink="/contact"
      />
    </div>
  );
};

export default Customs;
